import AutoReplenishmentMain from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentMain/AutoReplenishmentMain';

import { withAutoReplenishmentMainProps } from 'viewModel/richProfile/myAccount/autoReplenishment/autoReplenishmentMain/withAutoReplenishmentMainProps';

export default withAutoReplenishmentMainProps(AutoReplenishmentMain);
